<template>
  <div>
    <h5>Kreiraj novog administratora</h5>
    <form v-on:submit.prevent="onSubmit">
      <div class="form-group">
        <label for="firstNameLastName">Ime i prezime</label>
        <input
          type="text"
          class="form-control"
          id="firstNameLastName"
          placeholder="First and last name"
          v-model="name"
        />
      </div>
      <div class="form-group">
        <label for="exampleInputEmail1">Email address</label>
        <input
          type="email"
          class="form-control"
          id="exampleInputEmail1"
          aria-describedby="emailHelp"
          placeholder="Enter email"
          v-model="email"
        />
        <small id="emailHelp" class="form-text text-muted"
          >We'll never share your email with anyone else.</small
        >
      </div>
      <div class="form-group">
        <label for="exampleInputPassword1">Password</label>
        <input
          type="password"
          class="form-control"
          id="exampleInputPassword1"
          placeholder="Password"
          v-model="password"
        />
      </div>
      <button type="submit" class="btn btn-primary">Kreiraj account</button>
    </form>
  </div>
</template>
<script>
/*eslint-disable*/
export default {
  data() {
    return {
      name: "",
      email: "",
      password: "",
      type: "admin"
    };
  },
  methods: {
    onSubmit() {
      const newUser = {
        name: this.name,
        email: this.email,
        password: this.password,
        type: this.type
      };
      console.log(newUser);
      this.$store.dispatch("createAdminAccount", newUser);
    }
  }
};
</script>
<style></style>
